/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import ImageBannerOtt from '@dtvgo/image-banner';

/* Components */
import { BaseFocusableButton } from '../FocusableButton';

/* Utils */
import { ImageRatio } from '../../utils/constants';
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { withCursorVisibilityFilter } from '../../hocs/withCursorVisibilityFilter.hoc';

/* Hooks */
import useImageCard from '../../hooks/useImageCard';

/* Styles */
import './ImageBanner.scss';

const IMG_WIDTH = 182;
const IMG_DIMENSION = ImageRatio.SIXTEEN_BY_NINE;

const BG_WIDTH = 1520;
const BG_DIMENSION = ImageRatio.SIXTEEN_BY_NINE;

const FocusableButton = withCursorVisibilityFilter(BaseFocusableButton);

function ImageBanner({
  focused,
  className,
  item: collection,
  onMouseDown,
  onMouseEnter,
}) {
  const {
    headline, subtitle, description, buttonText, cardImages, iconImages,
  } = collection;

  const { imageUrl: iconImage } = useImageCard({
    images: iconImages,
    imageSize: IMG_WIDTH,
    aspectRatio: IMG_DIMENSION,
  });

  const { imageUrl: cardImage } = useImageCard({
    images: cardImages,
    imageSize: BG_WIDTH,
    aspectRatio: BG_DIMENSION,
  });

  return (
    <ImageBannerOtt
      className={
        `dtv-html5-c-image-banner ${focused ? 'dtv-html5-c-image-banner--focused' : ''
        } ${className}`
      }
      headline={headline}
      title={subtitle}
      subtitle={description}
      imageUrl={iconImage}
      backgroundImageUrl={cardImage}
    >
      <FocusableButton
        className="dtv-html5-c-image-banner__button"
        icon="play"
        primary
        onMouseDown={onMouseDown}
        onMouseEnter={onMouseEnter}
        focused={focused}
      >
        {buttonText}
      </FocusableButton>
    </ImageBannerOtt>
  );
}

ImageBanner.propTypes = {
  focused: PropTypes.bool.isRequired,
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

ImageBanner.defaultProps = {
  className: '',
  onMouseDown: undefined,
  onMouseEnter: undefined,
};

export default memo(withInteractiveFocusable()(memo(ImageBanner)));
